import Vue from "vue";
import VueRouter from "vue-router";
import Loading from "../views/loading.vue";
import Cyshow from "../views/cyShow.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/loading",
    name: "loading",
    component: Loading,
    meta: {
      title: '',
      requireAuth: true  // 是否需要判断是否登录,这里是需要判断
     },
  },
  {
    path: "/ai",
    name: "ai",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/aiView.vue"),
  },
  {
    path: "/",
    name: "cyshow",
    component: Cyshow,
    meta: {
      title: '',
      requireAuth: ''  // 是否需要判断是否登录,这里是需要判断
     },
  },
  {
    path: "/cyqyShow",
    name: "cyqyShow",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/cyqyShow.vue"),
    meta: {
      title: '',
      requireAuth: ''  // 是否需要判断是否登录,这里是需要判断
     },
  },
];

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
